<template>
  <div class="header">
    <div class="icons" @click="handlerGoback">
      <img src="http://cdn.gugusj.com/xdk/icon01.png" alt="">
    </div>
    <div class="center" v-show="showCenter">
      <div class="nav-group">
        <div class="lis" :class="active == '/home' ? 'active' : ''" @click="handlernav('/home')">
          <span class="lis-text">产品</span>
        </div>
        <div
          class="lis lis-ai"
          :class="active == '/merchantAssistant' ? 'active' : ''"
          @click="handlernav('/merchantAssistant')"
        >
          <span class="lis-text">招商助手</span>
          <span class="ai-tag">AI</span>
        </div>
        <div class="lis" :class="active == '/price' ? 'active' : ''" @click="handlernav('/price')">
          <span class="lis-text">定价</span>
        </div>
        <!-- <div class="lis" :class="active == 3 ? 'active' : ''" @click="handlernav(3)">工作台</div> -->
      </div>
    </div>
    <div class="rights">
      <div class="login" v-show="!$store.state.tokens" @click="handlerShows">登录 / 注册</div>

      <div class="user-profile" v-show="$store.state.tokens">
        <div class="user-trigger">
          <div class="avatar-wrap">
            <img class="avatar-img" v-if="avatarUrl" :src="avatarUrl" alt="用户头像">
            <span v-else class="avatar-fallback">XDK</span>
          </div>
          <div class="user-meta">
            <span class="user-nickname">{{ displayNickname }}</span>
            <span class="user-vip" v-if="vipLabel">{{ vipLabel }}</span>
          </div>
          <i class="el-icon-arrow-down user-arrow"></i>
        </div>
        <div class="user-dropdown">
          <div class="user-dropdown-panel">
          <div class="dropdown-header">
            <div class="avatar-wrap avatar-wrap--lg">
              <img class="avatar-img" v-if="avatarUrl" :src="avatarUrl" alt="用户头像">
              <span v-else class="avatar-fallback">XDK</span>
            </div>
            <div class="dropdown-user">
              <div class="dropdown-name">{{ displayNickname }}</div>
              <div class="dropdown-sub" v-if="vipLabel">{{ vipLabel }}</div>
            </div>
          </div>
          <div class="ctdvs">

            <div class="title1">{{ setviplever.vipLevel == 3 ? '续费' : '升级' }}{{
              setviplever.cardDefinition ? setviplever.cardDefinition.cardName : '' }}</div>
            <div class="title2">
              文案生成上限{{ setviplever.cardDefinition ? setviplever.cardDefinition.count : 0 }}次(有效期{{
                setviplever.cardDefinition ? setviplever.cardDefinition.durationDays : 0 }}天)
            </div>
            <div class="btns" @click="handlerTopathone"> {{ setviplever.vipLevel == 3 ? '立即续费' : '立即升级' }}</div>
          </div>
          <div class="list">
            <div class="lis" @click="handlerTopath(3)">
              <span>工作台</span>
              <span class="el-icon-arrow-right"></span>
            </div>
            <div class="lis" @click="handlerTopath(1)">
              <span>账号信息</span>
              <span class="el-icon-arrow-right"></span>
            </div>
            <div class="lis" @click="handlerTopath(2)">
              <span>订单管理</span>
              <span class="el-icon-arrow-right"></span>
            </div>
            <div class="lis" @click="handlerTopath(5)">
              <span>推荐中心</span>
              <span class="el-icon-arrow-right"></span>
            </div>
            <div class="lis" @click="handlerTopath(4)">
              <span>操作手册</span>
              <span class="el-icon-arrow-right"></span>
            </div>
          </div>
          <div class="line">

          </div>
          <div class="loginout" @click="handlerLogout">
            退出登录
          </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// import {getSmsCode} from '@/api/login'
import { getUserInfo } from '@/api/home'
export default {
  name: 'HeaderComponent',

  data() {
    return {
      active: '/home',
      actives: 1,
      showCenter: true,
      input3: "",
      cozeBg: false,
      ruleForm: {
        phone: "",
        code: ""
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      }
    }
  },
  computed: {
    avatarUrl() {
      let user = ""
      let userProfile = this.$store.state.user && this.$store.state.user.userProfile ? this.$store.state.user.userProfile : {}
      if (!userProfile.avatarUrl) {
        user = JSON.parse(localStorage.getItem('user')) || {}
      } else {
        user = this.$store.state.user || {}
      }
      return user.userProfile ? user.userProfile.avatarUrl : ''
    },
    nickname() {
      let user = ""
      let userProfile = this.$store.state.user && this.$store.state.user.userProfile ? this.$store.state.user.userProfile : {}
      if (!userProfile.avatarUrl) {
        user = JSON.parse(localStorage.getItem('user')) || {}
      } else {
        user = this.$store.state.user || {}
      }
      return user.userProfile ? user.userProfile.nickname : ''
    },
    setviplever() {
      let lervers = {}
      let setviplever = this.$store.state.setviplever
      console.log(setviplever, 'setviplever')
      if (!setviplever.vipLevel) {
        lervers = JSON.parse(localStorage.getItem('setviplever')) || {}
      } else {
        lervers = this.$store.state.setviplever || {}
      }
      return lervers
    },
    displayNickname() {
      return this.nickname || '用户'
    },
    vipLabel() {
      const card = this.setviplever.cardDefinition
      return card && card.cardName ? card.cardName : ''
    }
  },
  watch: {
    $route(to) {
      // console.log(to,from)
      this.active = to.fullPath
      if (to.fullPath == '/AccountSettings' || to.fullPath == '/cozeIndex') {
        this.showCenter = false
      } else {
        this.showCenter = true
      }
    },
  },
  created() {
    console.log(this.$store.state, 'this.$store.state.setviplever')
    let data = JSON.parse(localStorage.getItem('datas'))
    let token = data && data.qrAuth.accessToken ? data.qrAuth.accessToken : ""
    console.log(token, 'ppps')
    this.$store.commit('SETTOKENS', token)
    this.active = this.$route.fullPath
    if (this.active == '/AccountSettings' || this.active == '/cozeIndex') {
      this.showCenter = false
    } else {
      this.showCenter = true
    }
  },
  // mounted() {
  //   kg.captcha({
  //           // 绑定弹窗按钮
  //           button: "#captchaButton",
  //           float: "top",
  //           // 验证成功事务处理
  //           success: function (e) {
  //               console.log(e,'ppp');
  //               // 将验证成功后的 token 通过隐藏域传递到后端
  //               kg.$("#kgCaptchaToken").value = e["token"];
  //               kg.html(kg.$("#captchaButton"), "验证成功，请提交数据");
  //               kg.$("#captchaButton").style.background = '#DDDDDD'
  //           },

  //           // 验证失败事务处理
  //           failure: function (e) {
  //               console.log(e,'pppp');
  //               kg.html(kg.$("#captchaButton"), "验证失败，请重新验证");
  //               kg.$("#captchaButton").style.background = '#aaa'
  //           },

  //           // 点击刷新按钮时触发
  //           refresh: function (e) {
  //               console.log(e);
  //           }
  //       });
  // },

  methods: {
    handlernav(path) {
      this.active = path
      // 如果没有登录 判断 
      let datas = localStorage.getItem('datas')
      if (path == "/price" || path == "/merchantAssistant") {
        this.getuserinfo()
        // path = '/login'
        //   // 请求接口，判断是否登录
        //   // let res = await this.$request(getUserInfo, {})
        //   // //已登录
        //   // if(res.code == 0){
        //   //   path = '/price'
        //   // }else{
        //   //    // 没有登录
        //   //    localStorage.removeItem('datas')
        //   //    path = '/login'
        //   // }
      }
      this.$router.push({ path: path })
      // this.getuserinfo()
      // if (index == 1) {
      // } else if (index == 2) {
      //   this.$router.push({ path: '/home/ListPrice' })
      // }
    },
    async getuserinfo() {
      let res = await this.$request(getUserInfo, {})
      if (res.code != 0) {
        localStorage.removeItem('datas')
        localStorage.removeItem('user')
      }
      return res
    },
    handlerchanges(index) {
      this.actives = index

    },
    handlerShows() {
      this.$router.push({ path: '/login' })
    },

    handlerTopath(index) {
      // this.$router.push({ name: 'AccountSettings',params:{index:index}})
      switch (index) {
        case 1:
          this.$router.push({ path: '/AccountSettings', query: { index: index } })
          break;
        case 2:
          this.$router.push({ path: '/AccountSettings', query: { index: index } })
          break;
        case 3:
          this.$router.push({ path: '/xdkAi' })
          break;
        case 4:
          window.open('https://icntqmep7gqb.feishu.cn/wiki/WIShwL8IkiNWuckPVxKct4ugnfb?from=from_copylink', '_blank');
          break;
        case 5:
          this.$router.push({ path: '/recommendCenter' })
      }
      // this.$router.push({ path: '/AccountSettings',query:{index:index}})
    },
    handlerTopathone() {
      this.$router.push({ path: '/price' })
    },
    handlerTopathtwo() {
      this.$router.push({ path: '/xdkAi' })
    },
    handlerGoback() {
      this.$router.push({ path: '/' })
    },
    handlersend() {

      // let parmas = {
      //   phone:this.ruleForm.phone
      // }
      // this.$request(handlersend,parmas).then(res=>{
      //   console.log(res);
      // })
    },
    hadlerLogins(formName) {
      console.log('submit!');
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //退出登录
    handlerLogout() {
      sessionStorage.removeItem('datas')
      sessionStorage.removeItem('user')
      localStorage.removeItem('datas')
      localStorage.removeItem('user')
      localStorage.removeItem('wechatData')
      this.$message.success('退出成功')
      this.$store.commit('SETTOKENS', "")
      this.$router.push({ path: '/' })
    }
  }
}
</script>
<style lang="scss" scoped>
.cozeBg {
  background: transparent !important;
}

.header {
  width: 100%;
  height: 70px;
  background: rgba(17, 19, 24, 0.92);
  backdrop-filter: blur(12px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  border-bottom: 1px solid rgba(63, 87, 255, 0.12);

  .icons {
    width: 100px;
    height: 28px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .center {
    .nav-group {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 4px;
      border-radius: 22px;
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.08);
    }

    .lis {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      height: 36px;
      padding: 0 18px;
      border-radius: 18px;
      font-size: 15px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.72);
      border: 1px solid transparent;
      transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

      .lis-text {
        font-weight: 500;
        white-space: nowrap;
      }

      &:hover {
        color: #ffffff;
        background: rgba(63, 87, 255, 0.12);
        border-color: rgba(63, 87, 255, 0.28);
      }

      &.active {
        color: #ffffff;
        background: linear-gradient(135deg, rgba(63, 87, 255, 0.22) 0%, rgba(63, 87, 255, 0.1) 100%);
        border-color: rgba(63, 87, 255, 0.42);
        box-shadow: 0 0 10px rgba(63, 87, 255, 0.18);

        .lis-text {
          font-weight: 600;
        }
      }
    }

    .lis-ai {
      padding: 0 14px 0 16px;
      color: #ffffff;
      background: linear-gradient(135deg, rgba(63, 87, 255, 0.28) 0%, rgba(183, 58, 255, 0.22) 100%);
      border-color: rgba(63, 87, 255, 0.5);

      .lis-text {
        font-weight: 600;
      }

      .ai-tag {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        height: 18px;
        padding: 0 5px;
        font-size: 10px;
        font-weight: 700;
        line-height: 1;
        color: #ffffff;
        background: linear-gradient(90deg, #3F57FF, #B73AFF);
        border-radius: 4px;
        letter-spacing: 0.5px;
      }

      &:hover {
        background: linear-gradient(135deg, rgba(63, 87, 255, 0.36) 0%, rgba(183, 58, 255, 0.3) 100%);
        border-color: rgba(63, 87, 255, 0.72);
        box-shadow: 0 0 14px rgba(63, 87, 255, 0.32);
      }

      &.active {
        background: linear-gradient(135deg, rgba(63, 87, 255, 0.42) 0%, rgba(183, 58, 255, 0.36) 100%);
        border-color: #3F57FF;
        box-shadow: 0 0 16px rgba(63, 87, 255, 0.4);
      }
    }
  }

  .rights {
    position: relative;

    .login {
      width: 120px;
      height: 40px;
      background: linear-gradient(135deg, rgba(63, 87, 255, 0.85) 0%, rgba(99, 102, 241, 0.9) 100%);
      border: 1px solid rgba(63, 87, 255, 0.5);
      border-radius: 20px;
      text-align: center;
      line-height: 38px;
      cursor: pointer;
      transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

      &:hover {
        background: linear-gradient(135deg, #3F57FF 0%, #6366F1 100%);
        border-color: #3F57FF;
        box-shadow: 0 0 14px rgba(63, 87, 255, 0.35);
      }
    }

    .user-profile {
      position: relative;
      cursor: pointer;

      &:hover {
        .user-trigger {
          background: rgba(63, 87, 255, 0.14);
          border-color: rgba(63, 87, 255, 0.38);
        }

        .user-arrow {
          color: rgba(255, 255, 255, 0.9);
        }

        .user-dropdown {
          display: block;
        }
      }
    }

    .user-trigger {
      display: flex;
      align-items: center;
      gap: 10px;
      height: 42px;
      padding: 4px 12px 4px 4px;
      border-radius: 21px;
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: background 0.2s ease, border-color 0.2s ease;
    }

    .avatar-wrap {
      flex-shrink: 0;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid rgba(63, 87, 255, 0.55);
      background: linear-gradient(135deg, rgba(63, 87, 255, 0.35) 0%, rgba(183, 58, 255, 0.25) 100%);
      display: flex;
      align-items: center;
      justify-content: center;

      &--lg {
        width: 44px;
        height: 44px;
      }

      .avatar-img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }

      .avatar-fallback {
        font-size: 11px;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: 0.5px;
      }
    }

    .user-meta {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      min-width: 0;
      max-width: 120px;
    }

    .user-nickname {
      font-size: 14px;
      font-weight: 600;
      color: #ffffff;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .user-vip {
      margin-top: 2px;
      font-size: 11px;
      color: rgba(255, 255, 255, 0.55);
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .user-arrow {
      flex-shrink: 0;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.45);
      transition: color 0.2s ease, transform 0.2s ease;
    }

    .user-profile:hover .user-arrow {
      transform: rotate(180deg);
    }

    .user-dropdown {
      display: none;
      position: absolute;
      top: 100%;
      right: 0;
      width: 300px;
      padding-top: 10px;
      box-sizing: border-box;
      z-index: 9999;
      background: transparent;
      border: none;
      box-shadow: none;

      .user-dropdown-panel {
        border-radius: 16px;
        padding: 16px;
        box-sizing: border-box;
        background: rgba(26, 28, 36, 0.98);
        border: 1px solid rgba(63, 87, 255, 0.22);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.04);
        backdrop-filter: blur(16px);
      }

      .dropdown-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding-bottom: 14px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      }

      .dropdown-user {
        min-width: 0;
        flex: 1;
      }

      .dropdown-name {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        line-height: 1.3;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .dropdown-sub {
        margin-top: 4px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
      }

      .ctdvs {
        width: 100%;
        height: 109px;
        margin-top: 16px;
        background: url("http://cdn.gugusj.com/xdk/bg09.png") no-repeat;
        background-size: 100% 100%;
        padding: 15px 25px;
        box-sizing: border-box;
        text-align: left;
        border-radius: 12px;
        overflow: hidden;

        .title1 {
          font-size: 16px;
          font-weight: bold;
          color: #222222;
          text-align: left;
        }

        .title2 {
          font-size: 12px;
          color: #666666;
          margin-top: 5px;
        }

        .btns {
          width: 85px;
          height: 28px;
          border-radius: 28px;
          background: linear-gradient(135deg, #3F57FF 0%, #6366F1 100%);
          color: #ffffff;
          text-align: center;
          font-size: 12px;
          line-height: 28px;
          margin-top: 10px;
          cursor: pointer;
          transition: box-shadow 0.2s ease;

          &:hover {
            box-shadow: 0 0 12px rgba(63, 87, 255, 0.45);
          }
        }
      }

      .list {
        width: 100%;
        margin-top: 14px;

        .lis {
          width: 100%;
          height: 40px;
          padding: 0 12px;
          box-sizing: border-box;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          color: rgba(255, 255, 255, 0.82);
          font-size: 14px;
          transition: background 0.2s ease, color 0.2s ease;

          &:hover {
            background: rgba(63, 87, 255, 0.14);
            color: #ffffff;
          }

          .el-icon-arrow-right {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.35);
          }
        }
      }

      .line {
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.08);
        margin-top: 12px;
      }

      .loginout {
        height: 40px;
        margin-top: 8px;
        color: rgba(255, 255, 255, 0.72);
        text-align: left;
        padding: 0 12px;
        line-height: 40px;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease;

        &:hover {
          background: rgba(239, 68, 68, 0.12);
          color: #fca5a5;
        }
      }
    }
  }

  ::v-deep  .el-dialog__wrapper {
    background: rgba(0, 0, 0, .5);
  }

  ::v-deep  .el-dialog {
    background: rgba(0, 0, 0, 0);
  }

  ::v-deep  .el-dialog__header {
    display: none;
  }

  ::v-deep  .el-dialog__body {
    padding: 0;
  }

  .tops {
    height: 100%;
    height: 50px;
    position: relative;

    .icons {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: solid 2px #ffffff;
      box-sizing: border-box;
      position: absolute;
      right: -50px;
      top: 0;
      text-align: center;
      line-height: 40px;
      cursor: pointer;

      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }

  .dvboxs {
    width: 500px;
    height: 603px;
    border-radius: 20px;
    background: url("http://cdn.gugusj.com/xdk/bg08.png") no-repeat;
    background-size: 100% 100%;
    padding: 37px;
    box-sizing: border-box;
    position: relative;
    text-align: center;

    .top1 {
      width: 88px;
      height: 24px;
      background: url("http://cdn.gugusj.com/xdk/icon01.png") no-repeat;
      background-size: 100% 100%;
    }

    .titles {
      font-size: 32px;
      font-weight: bold;
      color: #222222;
      margin-top: 44px;
    }

    .list {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 32px;

      .lis {
        margin: 0 15px;
        font-size: 18px;
        position: relative;
        cursor: pointer;
      }

      .active {
        color: #3F57FF;

        &::after {
          content: "";
          width: 30px;
          height: 4px;
          background: #3F57FF;
          border-radius: 2px;
          position: absolute;
          left: 50%;
          bottom: -10px;
          transform: translateX(-50%);
        }
      }
    }

    .erlist {
      .erweima {
        width: 200px;
        height: 200px;
        padding: 10px;
        margin: 40px auto 0;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 10px;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .texts {
        margin-top: 20px;
        font-size: 16px;
        color: #666666;
      }
    }

    .phones {
      width: 365px;
      margin: 42px auto 0;

      .lis {
        margin-bottom: 20px;

        .btns {
          width: 100%;
          height: 56px;
          border-radius: 40px;
          cursor: pointer;
          background: linear-gradient(90deg, #B73AFF, #0CC1FE);
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          font-size: 20px;
        }
      }

      ::v-deep  .el-input__inner {
        height: 56px;
        line-height: 56px;
        border-radius: 56px;
        padding: 0 40px;
      }

      ::v-deep  .el-input__suffix {
        right: 10px;
        line-height: 56px;
        padding-right: 10px;
      }

      .sends {
        color: #3F57FF;
        cursor: pointer;
      }
    }

    .foot {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 40px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/HeaderComponent.vue